import React from "react";
import {useLocation} from "react-router";
import {css, Theme} from "@emotion/react";

import {pb} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";

export interface IProps {
    linkText: string;
    url: string;
    disableSelfLinking?: boolean;
}

export const OfferLocationLinksItem: React.FC<IProps> = (props) => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const {pathname} = useLocation();

    if (props.disableSelfLinking && pathname === props.url) {
        return null;
    }

    return (
        <li css={[locationLinkLi]}>
            <Link href={props.url} target={responsiveLinkTarget} css={linkStyle}>
                {props.linkText}
            </Link>
        </li>
    );
};

const locationLinkLi = css`
    list-style-type: none;
    ${pb()}
`;

const linkStyle = (theme: Theme) => css`
    color: ${theme.colors.gray[700]};

    &:hover,
    &:focus {
        color: ${theme.colors.gray[700]};
        text-decoration: underline;
    }
`;
import React from "react";
import {useLocation} from "react-router";
import {css, Theme} from "@emotion/react";

import {pb} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";

export interface IProps {
    linkText: string;
    url: string;
    disableSelfLinking?: boolean;
}

export const OfferLocationLinksItem: React.FC<IProps> = (props) => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const {pathname} = useLocation();

    if (props.disableSelfLinking && pathname === props.url) {
        return null;
    }

    return (
        <li css={[locationLinkLi]}>
            <Link href={props.url} target={responsiveLinkTarget} css={linkStyle}>
                {props.linkText}
            </Link>
        </li>
    );
};

const locationLinkLi = css`
    list-style-type: none;
    ${pb()}
`;

const linkStyle = (theme: Theme) => css`
    color: ${theme.colors.gray[700]};

    &:hover,
    &:focus {
        color: ${theme.colors.gray[700]};
        text-decoration: underline;
    }
`;
